import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApplicationRef, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {shareReplay, switchMap, tap} from 'rxjs/operators';
import {ConfigurationService} from '../../configuration/configuration-service';
import {ComuneModel, LocalitaModel, NazioneModel} from '../models/estremi-persona-fisica.model';

@Injectable({
	providedIn: 'root',
})
export class ModalitaPagamentoService {
	province$: Observable<Array<LocalitaModel>>;
	nazioni$: Observable<Array<NazioneModel>>;
	regioni$: Observable<Array<LocalitaModel>>;

	servicePaths: Map<string, string>;

	urlAnagrafe: string;

	constructor(
		private http: HttpClient,
		private configurationService: ConfigurationService,
		private appRef: ApplicationRef) {

		console.log('[ModalitaPagamentoService]');

		this.urlAnagrafe = configurationService.servicePaths.get("ANAGRAFE_MS_API_URL") + "/v1";
		console.log('[urlAnagrafe - lib]', this.urlAnagrafe);

		const lingua$ = configurationService.lingua$;
		// console.log('[lingua]', configurationService.servicePaths.get("I18N_MS_API_URL"));

		//TODO
		// const urlNazioni: string = this.paths.get_V1Nazioni();
		const urlNazioni: string = this.urlAnagrafe + "/nazioni";
		// console.log('[urlNazioni]', urlNazioni);

		this.nazioni$ = lingua$.pipe(
			switchMap(lingua =>
				this.http.get<Array<NazioneModel>>(
					urlNazioni, { headers: new HttpHeaders({ 'i18n_language': lingua }) }
				)
			),
			tap(_ => appRef.tick()),
			shareReplay()
		);

		//TODO
		// const urlProvince: string = this.paths.get_V1Province();
		const urlProvince: string = this.urlAnagrafe + '/province';
		// console.log('[urlProvince]', urlProvince);

		// TODO
		// const urlRegioni: string = this.urlAnagrafe + '/regioni';
		const urlRegioni: string = this.urlAnagrafe + '/regioni/nonSoppresse/';

		//TODO
		// this.province$ = this.http.get<Array<Localita>>(urlProvince);
		this.province$ = lingua$.pipe(
			switchMap(lingua =>
				this.http.get<Array<LocalitaModel>>(
					urlProvince, { headers: new HttpHeaders({ 'i18n_language': lingua }) }
				)
			),
			tap(_ => appRef.tick()),
			shareReplay()
		);

		this.regioni$ = lingua$.pipe(
			switchMap(lingua =>
				this.http.get<Array<LocalitaModel>>(
					urlRegioni, { headers: new HttpHeaders({ 'i18n_language': lingua }) }
				)
			),
			tap(_ => appRef.tick()),
			shareReplay()
		);
	}

	getProvince$(): Observable<Array<LocalitaModel>> {
		return this.province$;
	}

	getProvincePerRegione$(regione: LocalitaModel): Observable<Array<LocalitaModel>> {
		//TODO
		// return this.configurationService.lingua$
		// 	.pipe(switchMap(lingua => this.http.get<Array<Localita>>(
		// 		this.urlAnagrafe + `/regione/${regione.sigla}/province`,
		// 		{ headers: new HttpHeaders({ 'i18n_language': lingua }) }
		// 	)));
		const url: string = `${this.urlAnagrafe}/regione/${regione.sigla}/province/nonSoppresse/?codiceRegione=${regione.sigla}`;
		return this.configurationService.lingua$.pipe(
			switchMap(lingua =>
				this.http.get<Array<LocalitaModel>>(
					url, { headers: new HttpHeaders({ 'i18n_language': lingua }) }
				)
			),
			tap(_ => this.appRef.tick()),
			shareReplay());
	}

	getComuni$(siglaProvincia: string): Observable<Array<ComuneModel>> {
		//TODO
		// const url: string = this.paths.get_V1ComuniByProvincia(siglaProvincia);
		// const url: string = `${this.urlAnagrafe}/provincia/${siglaProvincia}/comuni`
		const url: string = `${this.urlAnagrafe}/provincia/${siglaProvincia}/comuni/nonSoppressi`;
		return this.http.get<Array<ComuneModel>>(url).pipe(shareReplay());
	}

	getComune$(codiceCatastale: string): Observable<ComuneModel> {
		const url: string = `${this.urlAnagrafe}/comune/codiceCatastale/${codiceCatastale}`;

		return this.http.get<ComuneModel>(url).pipe(shareReplay());
	}

	getNazioni$(): Observable<Array<NazioneModel>> {
		return this.nazioni$;
	}

	getCap$(idComune: string): Observable<Array<string>> {
		//TODO
		// const url: string = this.paths.get_V1CapByIdComune(idComune);
		const url: string = `${this.urlAnagrafe}/comuni/${idComune}/cap`
		return this.http.get<Array<string>>(url);
	}

	getRegioni$(): Observable<Array<LocalitaModel>> {
		return this.regioni$;
	}
}
